import { FC, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { AnchorPlacement } from 'interfaces/navigation'
import { getAnchorUrl } from 'helpers/pageHelpers'
import { activateAnchorActionCreator } from 'actions/navigationActions'
import { LOGIN_URL } from 'tangle-shared'
import { IS_STATUS_APP } from 'helpers/userAgentHelpers'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'

type NavigationRedirectProps = {
  to: AnchorPlacement
  push?: boolean
  search?: string
  onRedirect?: () => void
}

export const NavigationRedirect: FC<NavigationRedirectProps> = (props) => {
  const {
    to,
    push,
    search,
    onRedirect,
  } = props

  const url = getAnchorUrl(to)

  const dispatch = useStoreDispatch()
  useEffect(() => {
    dispatch(activateAnchorActionCreator(to))
    onRedirect && onRedirect()
  }, [dispatch, to, onRedirect])

  if (url === LOGIN_URL && IS_STATUS_APP) {
    return null
  }

  return (
    <Redirect
      to={{
        pathname: url,
        search,
      }}
      push={ push }
    />
  )
}

export default NavigationRedirect
